class ReferenceToggle {
  constructor(el) {
    this.el = el;
    this.$el = $(el);
    this.collapsible = '.reference__collapsible';
    this.$toggle = this.$el.find('.reference__toggle');
    this.$collapsible = this.$el.find(this.collapsible);
    this.$toggleIcon = this.$el.find('.reference__toggle-icon');
    this.ariaExpanded = 'aria-expanded';
    // Initialize after setting up properties
    this.init();
  }

  init() {
    // Wait for DOM to be ready
    this.bindEvents();
    this.initializeState();
  }

  bindEvents() {
    // Check if this.$toggle exists before binding events
    if (this.$toggle && this.$toggle.length > 0) {
      this.$toggle.on('click', (e) => {
        const $toggleBtn = $(e.currentTarget);
        const $collapsible = $toggleBtn.closest('.reference__content').find(this.collapsible);
        const $toggleIcon = $toggleBtn.find('.reference__toggle-icon');

        const expanded = $toggleBtn.attr(this.ariaExpanded) === 'true';
        $toggleBtn.attr(this.ariaExpanded, !expanded);

        if (expanded) {
          $collapsible.stop().slideUp(300);
          $toggleIcon.removeClass('icon-minus').addClass('icon-plus');
        } else {
          $collapsible.stop().slideDown(300);
          $toggleIcon.removeClass('icon-plus').addClass('icon-minus');
        }
      });
    }
  }

  initializeState() {
    // Initialize all references in collapsed state
    $('.reference__toggle').each((_, el) => {
      const $toggleBtn = $(el);
      const $collapsible = $toggleBtn.closest('.reference__content').find(this.collapsible);

      $toggleBtn.attr(this.ariaExpanded, 'false');
      $collapsible.hide();
    });
  }
}

// Initialize the class
$(document).ready(() => {
  const $modReference = $('.reference');
  $modReference.each((_, el) => {
    new ReferenceToggle(el);
  });
});
